import Api from "../Api";
import EventBus from "../EventBus";
import { createScript, generateQueryParamsFromObject } from "../utils/index";
export default class Revive {
  constructor(options) {
    this.bannerId = 0;
    this.refreshCount = 0;
    this.spc_url = "https://revive.plinga.de/www/delivery/spc.php";
    this.domain = options.domain;
    this.lang = options.language;
    this.gameName = options.gameName;
    this.platform = options.platform;
    this.userid = options.uid;
    this.openXZones = {
      popup: 526
    };
  }

  cacheBuster() {
    return Math.floor(Math.random() * 99999999999);
  }

  location() {
    return window.location;
  }

  referrer() {
    return document.referrer;
  }

  async loadBanners(rewards) {
    const params = await this.getParams(this.openXZones, rewards);
    const url = this.spc_url + "?" + generateQueryParamsFromObject(params);
    Api.fetchCampaigns({ url, userId: this.userid })
      .then(response => {
        createScript(response.data);
        return this.parseResponse();
      })
      .then(data => {
        new EventBus().broadcast("SHOW_BANNER", data);
      })
      .catch(err => {
        console.log(err);
      });
  }

  /*global OA_output*/
  /*eslint no-undef: "error"*/
  parseResponse() {
    return new Promise((resolve, reject) => {
      let target, zone;
      try {
        if (typeof OA_output !== "object") {
          return reject();
        }

        for (target in this.openXZones) {
          zone = this.openXZones[target];
          if (
            typeof OA_output[target] === "string" &&
            OA_output[target] !== "" &&
            OA_output[target].indexOf("/www/delivery/lg.php?") === -1
          ) {
            return resolve({
              target: target,
              zone: zone,
              code: OA_output[target]
            });
          }
        }
        reject("No campaign is found.");
      } catch (err) {
        reject("Error during printing or parsing our banners");
        console.log(err.message);
      }
    });
  }

  async getParams() {
    let cb, key, oXParams, oXZoneIds, value;
    cb = this.cacheBuster();
    oXZoneIds = "|";
    for (key in this.openXZones) {
      value = this.openXZones[key];
      oXZoneIds += "" + key + "=" + value + "|";
    }
    oXParams = {
      zones: oXZoneIds,
      nz: 1,
      blockcampaign: 1,
      charset: document.charset
        ? document.charset
        : document.characterSet
        ? document.characterSet
        : "",
      game: this.gameName,
      lang: this.lang,
      firstbuyer: this.firstBuyer ? 1 : 0,
      cb: cb,
      r: cb,
      refreshAttempt: this.refreshCount++,
      platform: this.platform,
      domain: this.domain
    };

    // Determine whether the user is non-payers on a payer.
    const paymentInfo = await Api.fetchPaymentInfo({
      userid: this.userid,
      platform: this.platform,
      game: this.gameName
    });

    oXParams.firstbuyer = paymentInfo.success
      ? paymentInfo?.result?.first_buyer
        ? 1
        : 0
      : 0;

    if (this.location()) {
      oXParams.loc = escape(this.location());
    }

    if (this.referrer()) {
      oXParams.referer = escape(this.referrer());
    }

    return oXParams;
  }
}
